import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom'; // 1. Importar useParams
import i18n from './i18n';
import '../styles-v2/Stats.css';
import { FaBuilding, FaCalendarAlt, FaHandsHelping } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

// El hook useCounter se mantiene igual (es pura lógica matemática)
const useCounter = (endValue, duration) => {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const hasAnimated = useRef(false);

    useEffect(() => {
        const elementoActual = ref.current;
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && !hasAnimated.current) {
                    hasAnimated.current = true;
                    let start = 0;
                    const increment = endValue / (duration / 16);
                    const counter = setInterval(() => {
                        start += increment;
                        if (start >= endValue) {
                            start = endValue;
                            clearInterval(counter);
                        }
                        setCount(Math.floor(start));
                    }, 16);
                }
            },
            { threshold: 0.5 }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (elementoActual) {
                observer.unobserve(elementoActual);
            }
        };
    }, [endValue, duration]);

    return [count, ref];
};

const Stats = () => {
    const { t } = useTranslation();
    const { lang } = useParams(); // 3. Obtenemos el idioma de la URL

    // 4. Sincronización obligatoria con la URL
    useEffect(() => {
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang).catch(err => console.error(err));
        }
    }, [lang]);

    const [clientesCount, clientesRef] = useCounter(200, 1500);
    const [proyectosCount, proyectosRef] = useCounter(500, 1500);
    const [aniosCount, aniosRef] = useCounter(30, 1500);

    return (
        <section id="stats" className="stats-block-container"> {/* Añadido ID por si quieres linkear aquí */}
            <div className="stats-container-grid">
                {/* Stat Item 1: Clientes */}
                <div className="stat-item" ref={clientesRef}>
                    <FaCalendarAlt size={60} className="stat-icon"/>
                    <h3>+{clientesCount}</h3>
                    <p>
                        <span>{t('stats.clients_top')}</span>
                        <span>{t('stats.clients_bottom')}</span>
                    </p>
                </div>

                {/* Stat Item 2: Proyectos */}
                <div className="stat-item" ref={proyectosRef}>
                    <FaBuilding size={60} className="stat-icon"/>
                    <h3>+{proyectosCount}</h3>
                    <p>
                        <span>{t('stats.projects_top')}</span>
                        <span>{t('stats.projects_bottom')}</span>
                    </p>
                </div>

                {/* Stat Item 3: Años */}
                <div className="stat-item" ref={aniosRef}>
                    <FaHandsHelping size={60} className="stat-icon"/>
                    <h3>+{aniosCount}</h3>
                    <p>
                        <span>{t('stats.years_top')}</span>
                        <span>{t('stats.years_bottom')}</span>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Stats;